import ResultStatus from "../../types/dtos/generic/ResultStatus";
import CoContributorNoteDto from "../../types/feedback/CoContributorNoteDto";
import CreateCoContributorNoteDto from "../../types/feedback/CreateCoContributorNoteDto";
import CreateFeedbackRequestDto from "../../types/feedback/CreateFeedbackRequestDto";
import FeedbackRequestDto from "../../types/feedback/FeedbackRequestDto";
import { apiClient } from "../apiClient";

class feedbackRequestApi {
  constructor(authToken: string | undefined) {
    this.accessToken = authToken;
  }

  accessToken: string | undefined;

  async createRequest(
    dto: CreateFeedbackRequestDto,
    onSuccess: (data: ResultStatus) => void,
    onError: (error: string) => void,
  ) {
    try {
      const response = await window.fetch(
        `${process.env.REACT_APP_API_URL}/dashboards/feedback-request/create-request`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.accessToken}`,
          },
          body: JSON.stringify(dto),
        }
      );

      const result: ResultStatus = await response.json();

      if (response.ok && result.success) {
        onSuccess(result);
      } else {
        onError(result.message || "Something went wrong. Please try again.");
      }
    } catch {
      onError("Something went wrong. Please try again.");
    }
  }

  getRequestsForAnswerSet(
    answerSetUniqueId: string,
    onSuccess: (data: FeedbackRequestDto[]) => void,
    onError: (error: any) => void,
  ) {
    return apiClient(
      this.accessToken,
      `dashboards/feedback-request/get-requests-for-answer-set?answerSetUniqueId=${answerSetUniqueId}`,
    ).then(
      (data) => {
        onSuccess(data as FeedbackRequestDto[]);
      },
      (error) => {
        onError(error);
      },
    );
  }

  deleteRequest(
    requestId: number,
    onSuccess: (data: ResultStatus) => void,
    onError: (error: any) => void,
  ) {
    return apiClient(
      this.accessToken,
      `dashboards/feedback-request/delete-request?requestId=${requestId}`,
    ).then(
      (data) => {
        onSuccess(data as ResultStatus);
      },
      (error) => {
        onError(error);
      },
    );
  }

  getPendingRequests(
    onSuccess: (data: FeedbackRequestDto[]) => void,
    onError: (error: any) => void,
  ) {
    return apiClient(
      this.accessToken,
      "dashboards/feedback-request/get-pending-requests",
    ).then(
      (data) => {
        onSuccess(data as FeedbackRequestDto[]);
      },
      (error) => {
        onError(error);
      },
    );
  }

  saveNote(
    requestId: number,
    dto: CreateCoContributorNoteDto,
    onSuccess: (data: ResultStatus) => void,
    onError: (error: any) => void,
  ) {
    return apiClient(
      this.accessToken,
      `dashboards/feedback-request/save-note?requestId=${requestId}`,
      {
        body: JSON.stringify(dto),
      },
    ).then(
      (data) => {
        onSuccess(data as ResultStatus);
      },
      (error) => {
        onError(error);
      },
    );
  }

  updateNote(
    noteId: number,
    dto: CreateCoContributorNoteDto,
    onSuccess: (data: ResultStatus) => void,
    onError: (error: any) => void,
  ) {
    return apiClient(
      this.accessToken,
      `dashboards/feedback-request/update-note?noteId=${noteId}`,
      {
        body: JSON.stringify(dto),
      },
    ).then(
      (data) => {
        onSuccess(data as ResultStatus);
      },
      (error) => {
        onError(error);
      },
    );
  }

  getNotesForAnswerSet(
    answerSetUniqueId: string,
    onSuccess: (data: CoContributorNoteDto[]) => void,
    onError: (error: any) => void,
  ) {
    return apiClient(
      this.accessToken,
      `dashboards/feedback-request/get-notes-for-answer-set?answerSetUniqueId=${answerSetUniqueId}`,
    ).then(
      (data) => {
        onSuccess(data as CoContributorNoteDto[]);
      },
      (error) => {
        onError(error);
      },
    );
  }
}

export default feedbackRequestApi;
